import React, { useState } from "react";
import {
  Arrow,
  Button,
  Container,
  Grid,
  Section,
} from "../../Styles/Global.Styled";
import { groupArrayByNumber } from "../../helpers/utilis";
import { css } from "styled-components";

const sectionStyle = css`
  align-items: center;
  flex-grow: 1;
  gap: 5vh;
`;
const widthStyle = css`
  width: 100%;
`;
const custBttn = (isActive) => css`
  font-size: 2.5vh;
  width: 4vh;
  text-decoration: ${isActive && "underline"};
  color: ${({ theme }) => (isActive ? theme.main : theme.secColor)};
`;

const ShopCarousel = ({ items = [], itemsPerSlide = 12, Component = "" }) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const slidesItems = groupArrayByNumber(items, itemsPerSlide);

  const handleClick = (value) => {
    //do or loop when first and user click left
    if (slideIndex === 0 && value === -1) {
      // return;
      return setSlideIndex(items.length - 1);
    }
    //do nothing or loop when slideIndex+1 is equal content length and user click right
    if (slideIndex + 1 === items.length && value === 1) {
      //return;
      return setSlideIndex(0);
    }
    return setSlideIndex((prev) => prev + value);
  };

  return (
    <Section $baseStyle={sectionStyle} $mStyle={widthStyle}>
      <Grid>
        {slidesItems.length > 0
          ? slidesItems[slideIndex].map((item, index) => (
              <Component key={index} item={item} />
            ))
          : null}
      </Grid>
      {slidesItems.length > 1 ? (
        <Container>
          <Button onClick={() => handleClick(-1)}>
            <Arrow $direction="left" />
          </Button>
          {slidesItems.map((_, index) => (
            <Button
              key={index}
              onClick={() => setSlideIndex(index)}
              $baseStyle={custBttn(index === slideIndex)}
            >
              {index + 1}
            </Button>
          ))}
          <Button onClick={() => handleClick(1)}>
            <Arrow $direction="right" />
          </Button>
        </Container>
      ) : items.length === 1 ? (
        <Button $baseStyle={custBttn(true)}>1</Button>
      ) : null}
    </Section>
  );
};

export default ShopCarousel;
